module.exports = __webpack_public_path__ + "img/sushiohnehintergrund.e148e2a8.png";